export class DateExtensions {
  public static addTimezoneOffset(date: Date, offset: string): Date {
    let dateMillis = date.getTime(),
      newDate = new Date();

    newDate.setTime(dateMillis + this.calculateOffset(offset));
    return newDate;
  }

  public static removeZoneOffset(date: Date, offset: string): Date {
    let dateMillis = date.getTime(),
      newDate = new Date();

    newDate.setTime(dateMillis - this.calculateOffset(offset));
    return newDate;
  }

  public static removeTimezoneOffset(date: Date, offset: string): Date {
    let newDate: Date;
    date = this.removeLocalOffset(date);

    if (offset) {
      newDate = DateExtensions.removeZoneOffset(date, offset || "");
    } else {
      newDate = date;
    }
    return newDate;
  }

  private static calculateOffset(offset: string): number {
    let parts = offset.split(/:/);
    return (parseInt(parts[0], 10) * 60 * 60 * 1000) +
      (parseInt(parts[1], 10) * 60 * 1000) +
      (parseInt(parts[2], 10) * 1000);
  }

  public static addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  public static removeLocalOffset(date: Date) {
    let dateNow: Date = new Date();
    let localOffset = dateNow.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - localOffset);
    return date;
  }

  public static addLocalOffset(date: Date) {
    let dateNow: Date = new Date();
    let localOffset = dateNow.getTimezoneOffset();
    date.setMinutes(date.getMinutes() + localOffset);
    return date;
  }

  public static countdown(startDate: Date, endDate: Date) {
    let result = "";
    let diff = moment.duration(moment(endDate).diff(moment(startDate)));

    if (diff.years() < 0 || diff.months() < 0 || diff.days() < 0 || diff.hours() < 0 || diff.minutes() < 0)
      result += "-";
    if (diff.years() !== 0)
      result += Math.abs(diff.years()) + "y ";
    if (diff.months() !== 0)
      result += Math.abs(diff.months()) + "m ";
    if (diff.days() !== 0)
      result += Math.abs(diff.days()) + "d ";
    if (diff.hours() !== 0)
      result += Math.abs(diff.hours()) + "h ";

    result += Math.abs(diff.minutes()) + "min";
    return result;
  }
}
